// index.jsx
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

// i18n (must be imported once at app start)
import "./i18n";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const container = document.getElementById("root");
const tree = (
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>
);

const start = () => {
  // Prerendered pages ship real HTML inside #root: hydrate it. Everything
  // else (article pages, /user area, unknown paths) renders client-side.
  if (container.hasChildNodes()) hydrateRoot(container, tree);
  else createRoot(container).render(tree);
};

// Use the language in the URL for the very first render so it matches the
// prerendered markup (the language detector may otherwise pick another one).
const m = window.location.pathname.match(/^\/(en|id)(\/|$)/);
if (m) i18n.changeLanguage(m[1]).then(start, start);
else start();
